import React, { useState, useEffect } from "react"
import { Col, Row, Button } from "react-bootstrap"
import Select from "react-select"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
//css
import "./../Reports.css"

import {
  numberFormat,
  selectDropdownStyle,
  TokenExpiry,
} from "../../../Helpers/Utils/Common"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import Moment from "moment"
import * as XLSX from "xlsx"
import { CSVLink } from "react-csv"
import DatePicker from "react-datepicker"
import { useNavigate, useParams } from "react-router-dom"

import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import { getReceivableAging } from "../../../Helpers/apiCalls/WholesaleReports/ReceivableAging"
import Footer from "../../../Components/Footer/Footer"
import TableWithDynamicPagination from "../../../Components/TableTemplate/TableWithDynamicPagination"

export default function ReceivablesAgingReport() {
  const [inactive, setInactive] = useState(true)
  const [filterConfig, setFilterConfig] = useState({
    customer_id: "",
    page: 1,
  })
  const [showLoader, setShowLoader] = useState(false)
  const [allData, setAllData] = useState([])
  const [totalReceivables, setReceivables] = useState({})
  const [customers, setCustomers] = useState([])
  const [totalItems, setTotalItems] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 10

  const handlePageChange = (page) => {
    setCurrentPage(page)
    setFilterConfig((prev) => ({
      ...prev,
      page: page,
    }))
  }

  //Function to fetch customer
  async function fetchcustomers() {
    setShowLoader(true)
    setCustomers([])

    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.map((customer) => {
        var info = customer
        info.name = "customer_id"
        info.select_variable = "customer_id_value"
        info.label = customer.trade_name
        info.value = customer.id
        return info
      })
      setCustomers([{ label: "All Customers", value: "" }, ...customers])
    }
    setShowLoader(false)
  }

  //Function to fetch table data
  async function fetchData() {
    setShowLoader(true)
    setAllData([])
    setTotalItems(0)

    const response = await getReceivableAging(filterConfig)
    console.log(response)

    if (response.data) {
      var customerData = response.data.data.map((data) => {
        var info = data
        info.name = "customer_id"
        info.select_variable = "customer_id_value"
        info.label = data.trade_name
        info.value = data.id
        info.total_balance = numberFormat(data.total_balance)
        return info
      })
      var receivables = response.data.summary
      setReceivables(receivables)
      setAllData(customerData)
      setTotalItems(response.data.size)
      console.log(response.data.size)
    }
    setShowLoader(false)
  }

  function handleExport() {
    const header = ["", ""]
    const meta = [
      ["REPORT TITLE:", "RECEIVABLES AGING REPORT"],
      [
        "CUSTOMER ID:",
        filterConfig.customer_id !== "" &&
        filterConfig.customer_id !== undefined
          ? filterConfig.customer_id
          : "All Customers",
      ],
    ]

    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: header,
    })

    /* generate worksheet and workbook */
    const workbook = XLSX.utils.book_new()
    let rowIndex = 6 // Start row for data

    // Add headers
    const headers = [
      ["CUSTOMER", "CURRENT", "1-30", "31-60", "61-90", "ABOVE 90", "TOTAL"],
    ]
    XLSX.utils.sheet_add_aoa(sheet, headers, { origin: "A6" })

    // Add data
    let rowDataIndex = 7 // Start row index for data
    allData.forEach(
      ({
        trade_name,
        current,
        one_to_thirty,
        thirtyone_to_sixty,
        sixtyone_to_ninety,
        above_ninety,
        total_balance,
      }) => {
        const currentRows = stringifyAgingData(current)
        const oneToThirtyRows = stringifyAgingData(one_to_thirty)
        const thirtyOneToSixtyRows = stringifyAgingData(thirtyone_to_sixty)
        const sixtyOneToNinetyRows = stringifyAgingData(sixtyone_to_ninety)
        const aboveNinetyRows = stringifyAgingData(above_ninety)

        const maxLength = Math.max(
          currentRows.length,
          oneToThirtyRows.length,
          thirtyOneToSixtyRows.length,
          sixtyOneToNinetyRows.length,
          aboveNinetyRows.length
        )
        for (let i = 0; i < maxLength; i++) {
          const rowData = [
            trade_name,
            currentRows[i] || "",
            oneToThirtyRows[i] || "",
            thirtyOneToSixtyRows[i] || "",
            sixtyOneToNinetyRows[i] || "",
            aboveNinetyRows[i] || "",
            i === 0 ? total_balance : "", // Add total_receivables only once
          ]
          XLSX.utils.sheet_add_aoa(sheet, [rowData], {
            origin: `A${rowDataIndex}`,
          })
          rowDataIndex++
        }
      }
    )

    XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" })
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1")

    XLSX.writeFile(
      workbook,
      `ReceivableAgingReport (${Moment().format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    )
  }

  // Helper function to stringify aging data
  function stringifyAgingData(agingData) {
    return agingData.map(({ invoice_no, total_balance }) => [
      `Invoice # ${invoice_no} = ${numberFormat(total_balance)}`,
    ])
  }

  function handleViewSalesInvoice(invoice_id) {
    window.open(
      //"/se/purchaseinvoices/print/" + invoice_id,
      "/wholesaleinvoice/print/" + invoice_id,
      "_blank"
    )
  }

  function getLabel(row) {
    var idUsed
    // if (
    //   row.invoice_no &&
    //   row.invoice_no !== "undefined" &&
    //   row.invoice_no !== "null"
    // ) {
    //   console.log("if")
    //   idUsed = row.invoice_no
    // } else if (row.dr_no && row.dr_no !== "undefined" && row.dr_no !== "null") {
    //   idUsed = row.dr_no
    // } else if (
    //   row.waybill_no &&
    //   row.waybill_no !== "undefined" &&
    //   row.waybill_no !== "null"
    // ) {
    //   idUsed = row.waybill_no
    // } else if (row.invoice_no && !row.invoice_no) {
    //   idUsed = row.invoice_id
    // }

    if (row.invoice_no !== null) {
      idUsed = row.invoice_no
    } else if (row.dr_no !== null) {
      idUsed = row.dr_no
    } else if (row.waybill_no !== null) {
      idUsed = row.waybill_no
    } else {
      idUsed = row.invoice_id
    }

    return (
      <>
        {/* <button
                    type="button"
                    className="button-secondary table-button me-3"
                    onClick={() => handleViewSalesInvoice(row.invoice_id)}
                >
                    {`Invoice No. # ${idUsed}`} <br/>{`${numberFormat(row.total_balance)}`}
                </button> */}
        <button
          type="button"
          className="button-secondary table-button p-1"
          onClick={() => handleViewSalesInvoice(row.invoice_id)}
        >
          {`Invoice # ${idUsed}`} - {`${numberFormat(row.total_balance)}`}
        </button>
      </>
    )
  }

  function splitData(row, header) {
    const split = row[header]

    return (
      <Row>
        {split.map((data) => {
          return <label>{getLabel(data)}</label>
        })}
      </Row>
    )
  }

  function ActionBtn(row) {
    return (
      <button
        class="btn btn-sm view-btn-table"
        onClick={() => handleSOA(row.id)}
      >
        Print
      </button>
    )
  }

  function handleSOA(customer_id) {
    window.open(
      // "/se/purchaseinvoices/print/" + invoice_id,
      // "_blank"
      "/statementofaccount/" + customer_id
    )
  }

  useEffect(() => {
    fetchData()
  }, [filterConfig, currentPage])

  useEffect(() => {
    fetchcustomers()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              Receivables Aging Report{" "}
            </h1>
          </Col>
        </Row>

        <div className="tab-content">
          {/* filters */}
          {/* <div className="my-2 px-2 PO-filters d-flex">
                        <span className="me-1 align-middle mt-3 ps-label">
                            Filter By:
                        </span>
                        <Select
                            className="dropsearch-filter px-0 py-0 mt-2 me-2"
                            classNamePrefix="react-select"
                            placeholder="Select Customer"
                            styles={selectDropdownStyle}
                            options={customers}
                            onChange={(e)=>{
                                setFilterConfig((prev) => {
                                    return { ...prev, customer_id: e.value };
                                });
                            }}
                        />
                    </div> */}
          <Row className="mb-2 mt-2 mt-lg-0">
            <Col>
              <div className="my-2 px-4 PO-filters d-flex flex-row gap-2 mb-2 filter flex-column">
                <span className="me-4 align-middle d-none d-md-inline mt-2">
                  Filter By:
                </span>
                <div className="row flex">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <Select
                      className="dropsearch-filter px-0 py-0 me-2"
                      classNamePrefix="react-select"
                      placeholder="Select Customer"
                      styles={selectDropdownStyle}
                      // value={branch}
                      options={customers}
                      onChange={(e) => {
                        setFilterConfig((prev) => {
                          return { ...prev, customer_id: e.value }
                        })
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="my-2 px-2 mb-3 PO-filters d-flex justify-content-center">
            <span className="me-4 ml-4 align-middle ps-label">
              Total Receivables: {numberFormat(totalReceivables.total_balance)}
            </span>
          </div>

          <div className="below">
            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                // "-",
                "CUSTOMER",
                "CURRENT",
                "1-30",
                "31-60",
                "61-90",
                "ABOVE 90",
                "TOTAL",
                "ACTIONS",
              ]}
              headerSelector={[
                // "-",
                "trade_name",
                "current",
                "one_to_thirty",
                "thirtyone_to_sixty",
                "sixtyone_to_ninety",
                "above_ninety",
                "total_balance",
              ]}
              tableData={allData}
              ActionBtn={(row) => ActionBtn(row)}
              currentAging={(row) => splitData(row, "current")}
              oneToThirty={(row) => splitData(row, "one_to_thirty")}
              thirtyOneToSixty={(row) => splitData(row, "thirtyone_to_sixty")}
              sixtyOneToNinety={(row) => splitData(row, "sixtyone_to_ninety")}
              aboveNinetyAging={(row) => splitData(row, "above_ninety")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-5" />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
